import React from 'react';
import styled from 'styled-components';

import { Link } from 'components/link';
import colors from 'src/constants/styles/colors';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import media from 'constants/styles/media';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { APP_URL, PHONE_NUMBER_DISPLAY, PHONE_NUMBER_E164 } from 'constants/index';
import { navItems } from '../navItems';
import accountIcon from '../../../images/svg/account.svg';

const SNav = styled.nav`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 34px;
    margin-left: 48px;
    flex: 1;
    min-width: 0;
    @media (max-width: ${media.desktop}) {
        display: none;
    }
`;

type ListDirection = 'row' | 'column';

const SList = styled.ul<{ $direction: ListDirection; $gap: string }>`
    height: 100%;
    display: flex;
    align-items: ${(p) => (p.$direction === 'column' ? 'flex-start' : 'center')};
    flex-direction: ${(p) => p.$direction};
    list-style: none;
    gap: ${(p) => p.$gap};
    margin: 0;
    padding: 0;
`;

const SListItem = styled(AnchorLink)`
    cursor: pointer;
    color: ${colors.gray_40};
    text-decoration: none;
    display: inline-block;
    position: relative;
    background-image: linear-gradient(${colors.white}, ${colors.white});
    background-repeat: no-repeat;
    background-position: 50% 100%;
    background-size: 0% 2px;
    font-size: 18px;
    line-height: 26px;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    transition: color 0.3s ease, text-shadow 0.3s ease, background-size 0.3s ease;

    :hover {
        color: ${colors.white};
        text-shadow: 0 0 0.01px ${colors.white};
        background-size: 100% 2px;
    }
`;

const SLinksWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 34px;
`;

const SLink = styled(Link)`
    && {
        color: ${colors.white};
        padding: 0;
    }
`;

interface NavItemsProps {
    direction?: ListDirection;
    gap?: string;
    onNavigate?: () => void;
}

export const NavItems = ({ direction = 'row', gap = '48px', onNavigate }: NavItemsProps) => {
    const { t } = useTranslation();

    return (
        <SList $direction={direction} $gap={gap}>
            {navItems.map(({ path, text }) => (
                <SListItem to={path} key={path} onAnchorLinkClick={onNavigate}>
                    {t(text)}
                </SListItem>
            ))}
        </SList>
    );
};

export const Nav = () => {
    const { t } = useTranslation();

    return (
        <SNav>
            <NavItems />
            <SLinksWrapper>
                <Link
                    href={`tel:${PHONE_NUMBER_E164}`}
                    title={t('navigation.button')}
                    variant="outlined"
                    aria-label={`${t('navigation.button')}: ${PHONE_NUMBER_DISPLAY}`}
                />
            </SLinksWrapper>
        </SNav>
    );
};

/*
<SLink
    href={`${APP_URL}/login`}
    title={t('navigation.link')}
    variant="plain"
    prependIcon={<img src={accountIcon} alt="login" />}
/>
*/
